const CSV_BOM = '\uFEFF';

export const rowsToCsv = (rows: string[][]): string => {
    return rows
        .map(row => row
            .map(cell => `"${String(cell ?? '').replace(/"/g, '""')}"`)
            .join(','))
        .join('\r\n');
};

export const downloadCsv = (csv: string, filename: string): void => {
    const url = URL.createObjectURL(
        new Blob([ CSV_BOM + csv ], { type: 'text/csv;charset=utf-8' }),
    );

    const link = document.createElement('a');

    link.href = url;
    link.download = filename;
    link.click();

    URL.revokeObjectURL(url);
};
